import Util from "@/util/util";

export default {
    clearUser() {
        this.userInfo = null;
    },
    userInfo: null,
    // 按钮是否有操作权限，用于table-button和page-button，返回true or false
    buttonHasRight(hasPerm, hasAnyPerms, hasAllPerms, page) {
        return new Promise(resolve => {
            // 读取数据，不限制
            this.getUserInfo().then(user => {
                let access = user.accessModules;
                // 如果是超级管理员,有全部权限
                if (user.roleType === 1) {
                    resolve(true);
                    return;
                }
                // 如果按钮未声明权限，默认有权限
                if (!hasPerm && !hasAnyPerms && !hasAllPerms) {
                    resolve(true);
                    return;
                }

                // 获取path
                let path = page.route.path;
                let result = []
                for (let i = 0; i < access.length; i++) {
                    if (path.indexOf(access[i].url) > -1) {
                        if (access[i].accessModel.length === 0) {
                            result.push(false);
                            // resolve(false);
                        }
                        // 只含有一种权限
                        if (hasPerm) {
                            result.push(this.processHasPerm(access[i].accessModel, hasPerm));
                            // resolve(this.processHasPerm(access[i].accessModel, hasPerm));
                        }
                        // 具有任意一种权限
                        if (hasAnyPerms) {
                            result.push(this.processHasAnyPerms(access[i].accessModel, hasAnyPerms))
                            // resolve(this.processHasAnyPerms(access[i].accessModel, hasAnyPerms));
                        }
                        // 具备所有权限
                        if (hasAllPerms) {
                            result.push(this.processHasAllPerms(access[i].accessModel, hasAllPerms));
                            // resolve(this.processHasAllPerms(access[i].accessModel, hasAllPerms));
                        }
                    }
                }
                if(result.length === 0){
                    resolve(true);
                }
                if(result.length > 0 && result.indexOf(true) > -1){
                    resolve(true);
                }
                resolve(false);
            })
        })
    },
    // 获取用户信息
    getUserInfo() {
        return new Promise((resolve) => {
            if (this.userInfo) {
                resolve(this.userInfo);
            } else {
                Util.getUserInfo().then(user => {
                    this.userInfo = user;
                    resolve(user);
                })
            }
        });
    },
    processHasPerm(accessList, perm) {
        // 判断权限列表是否为空
        for (let j = 0; j < accessList.length; j++) {
            if (accessList[j] === perm) {
                return true
            }
        }
        return false
    },
    processHasAnyPerms(accessList, perms) {
        perms = perms.split(",");
        for (let i = 0; i < accessList.length; i++) {
            for (let j = 0; j < perms.length; j++) {
                if (accessList[i] === perms[j]) {
                    return true
                }
            }
        }
        return false
    },
    processHasAllPerms(accessList, perms) {
        perms = perms.split(",");
        for (let j = 0; j < perms.length; j++) {
            let exist = false;
            for (let i = 0; i < accessList.length; i++) {
                if (perms[j] === accessList[i]) {
                    exist = true;
                    break
                }
            }
            if (!exist) {
                return false;
            }
        }
        return true;
    }
}